// extracted by mini-css-extract-plugin
export default {"lineInfo":"style_lineInfo__TWuA5"};